module.exports = {
	"customers": {
		"attributes": {
			"email": "Email",
			"name": "Nome",
			"password": "Senha",
			"cpf": "CPF",
			"company_name": "Razão social",
			"trade_name": "Nome fantasia",
			"cnpj": "CNPJ",
			"code": "Código",
			"phone": "Telefone",
			"customer_code": "Código identificador do estabelecimento",
			"mail": "E-mail",
			"id": "Identificador",
			"type": "Tipo",
			"status": "Status",
			"personal": "Física",
			"customer": "Jurídica",
			"person_type": "Tipo pessoa",
			"client_name": "Nome do cliente",
			"address": {
				"street": "Rua",
				"complement": "Complemento",
				"city": "Cidade",
				"state": "Estado",
				"neighborhood": "Bairro",
				"number": "Número",
				"postal_code": "CEP"
			},
			"contact": {
				"contact_type": "Tipo de contato",
				"area_code": "DDD",
				"number": "Número de contato"
			}
		},
		"modal_inactive": {
			"inactive_subscriber": "Inativar cliente",
			"inactive_warning": "Tem certeza que deseja desativar o assinante?",
			"inactive_confirm": "<p>Inativar Assinante <strong>%{customer}</strong>?</p>",
			"subscriber_inactived_with_success": "Assinante %{name} inativado."
		},
		"modal_contract": {
			"choose_plans": "Escolha os planos que deseja adicionar ao contrato.",
			"selected_plans": "Planos Selecionados",
			"perform_contract": "Realizar contratação"
		},
		"placeholder": {
			"id_example": "Ex.: 123",
			"name_example": "Ex.: José",
			"email_example": "Ex.: jose@example.com",
			"customer_code_example": "Ex.: IMP22",
			"document_example": "Ex.: 10315815884"
		},
		"main": {
			"title": "Clientes",
			"edit": "Editar",
			"create_contract": "Criar assinatura",
			"customer_location": "Endereço do cliente",
			"optional_personal_info": "Informações Pessoais",
			"customer_information": "Informações do cliente",
			"subscribers": "Clientes",
			"subscribers_list": "Lista de clientes cadastrados",
			"details": "Detalhes",
			"active": "Ativo",
			"inactive": "Inativo",
			"register_as_legal_entity": "Cadastrar cliente como pessoa jurídica"
		},
		"show": {
			"view_subscriber": "Visualizar cliente cadastrado",
			"code": "Código",
			"customer_code": "Código identificador do estabelecimento",
			"since": "Cliente desde",
			"company_name": "Razão Social",
			"trade_name": "Nome Fantasia",
			"subscriber_status": "Status do cliente",
			"subscriber_type": "Tipo cliente",
			"active_plans": "Planos ativos",
			"change": "Alterar",
			"subscriber_data": "Dados do cliente",
			"address": "Informações de endereço",
			"name": "Nome",
			"mail": "E-mail",
			"cpf": "CPF",
			"cnpj": "CNPJ",
			"phone": "Telefone",
			"subscriptions_history": "Histórico de assinaturas",
			"contract_plan": "Plano contratado",
			"subscription_init": "Inicio assinatura",
			"subscription_end": "Fim assinatura",
			"duration_charge": "Duração da cobrança",
			"status": "Status",
			"last_invoices": "Últimas faturas",
			"subscription": "Assinatura",
			"value": "Valor",
			"view_all_invoices": "Visualizar todas faturas",
			"personal": "Pessoa Física",
			"customer_person": "Pessoa Jurídica",
			"active_subscriptions": "Assinaturas ativas",
			"details": "Visualizar cliente"
		},
		"new": {
			"new_customer": "Incluir novo cliente",
			"edit_customer": "Editar cliente"
		},
		"alert": {
			"created": "Cliente criado com sucesso",
			"updated": "Cliente atualizado com sucesso",
			"not_created": "Falha ao criar cliente",
			"not_updated": "Falha ao atualizar cliente",
			"inactivated": "Cliente inativado com sucesso",
			"not_found": "Cliente não encontrado"
		},
		"button": {
			"contract": "Contratar"
		},
		"filter": {
			"document": "Documento"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/customers/pt-BR.yml
// module id = 580
// module chunks = 1